'use client';

import { FC } from 'react';
import clsx from 'clsx';

import { useIsMobile } from '@contexts/mobile-detector-provider';
import FiltersBarMobile from '../filters-bar-mobile/FiltersBarMobile';
import { FiltersBar } from '../FiltersBar/FiltersBar';
import ProductCatalog from '../products-catalog';

import classes from './CatalogContainer.module.scss';

interface ICatalogContainerProps {
  withOutFilterBar?: boolean;
  notFoundMessage?: string;
  pageTitle?: string;
}

const CatalogContainer: FC<ICatalogContainerProps> = ({ withOutFilterBar, notFoundMessage, pageTitle }) => {
  const isMobile = useIsMobile();

  return (
    <div className={clsx(classes.wrapper, { [classes.wrapperWithOutFilterBar]: withOutFilterBar })}>
      <div className={classes.container}>
        {isMobile ? (
          <FiltersBarMobile withOutFilterBar={withOutFilterBar} />
        ) : !withOutFilterBar ? (
          <div className={classes.filters}>
            <FiltersBar />
          </div>
        ) : null}
        <ProductCatalog pageTitle={pageTitle} notFoundMessage={notFoundMessage} />
      </div>
    </div>
  );
};

export { CatalogContainer };
